import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { SubscriptionItemUsageRecordFormSchemaValues } from 'src/features/subscriptionItemUsageRecords/utils/formSchema';
import { SubscriptionItemUsageRecord } from 'src/features/subscriptionItemUsageRecords/utils/types';

const RESOURCE = '/subscriptions/subscription-item-usage-record/';

type MutationFnType = typeof mutationFn;

interface DTO extends SubscriptionItemUsageRecordFormSchemaValues {
    subscription_item: string;
}

const mutationFn = (data: DTO): Promise<SubscriptionItemUsageRecord> =>
    axios.post(formatResourcePath(RESOURCE), data);

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateSubscriptionItemUsageRecord };
